/**
 * @internal
 */
export class AttrJsonUser {
  CanDevelop: boolean;

  // new v13
  CanAdmin: boolean;
}
